// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorMessage_container__3GWuM","btn-close":"ErrorMessage_btn-close__uapxu"};